import imgRouter from '../assets/product_router.png';
import imgRack from '../assets/product_rack.png';
import imgCable from '../assets/product_cable.png';

const products = [
  {
    id: 1,
    slug: "routeur-cisco-isr-1100",
    img: imgRouter,
    name: "Routeur Cisco ISR 1100 Series",
    category: "Réseau Actif",
    description: "Routeur professionnel sécurisé pour PME. VPN intégré, double WAN, pare-feu embarqué.",
    longDescription: "Le Cisco ISR 1100 est la solution idéale pour les PME sénégalaises cherchant un routeur fiable et performant. Il intègre un pare-feu de nouvelle génération, un VPN SSL/IPSec pour le télétravail sécurisé, et une double connexion WAN pour la redondance Internet. Compatible avec les offres fibre et ADSL des opérateurs locaux (Orange SN, Free SN, Expresso).",
    specs: [
      { label: "Ports WAN", value: "2x GE (Fibre/ADSL)" },
      { label: "Ports LAN", value: "4x GE PoE" },
      { label: "Débit VPN", value: "250 Mbps" },
      { label: "Utilisateurs max", value: "50 postes" },
      { label: "Garantie", value: "12 mois constructeur" },
      { label: "Support ETCS", value: "Installation incluse à Dakar" },
    ],
    price: "285 000 F CFA",
    priceNum: 285000,
    stock: true,
    stockLabel: "En stock à Dakar"
  },
  {
    id: 2,
    slug: "baie-brassage-42u",
    img: imgRack,
    name: "Baie de Brassage 42U avec PDU",
    category: "Infrastructure",
    description: "Armoire réseau 42U avec gestion de câbles intégrée, ventilation active et PDU 16A.",
    longDescription: "Cette baie de brassage 42U est conçue pour héberger l'ensemble de vos équipements réseau et serveurs. Elle intègre un système de gestion de câbles vertical et horizontal, une ventilation par 4 ventilateurs avec thermostat, et un PDU 16A avec 8 prises C13. Structure en acier renforcé, portes avant et arrière verrouillables. Parfaite pour les salles serveurs professionnelles au Sénégal.",
    specs: [
      { label: "Hauteur utile", value: "42U (2000mm)" },
      { label: "Profondeur", value: "1000mm" },
      { label: "Charge max", value: "800 kg" },
      { label: "PDU", value: "16A, 8x C13" },
      { label: "Ventilation", value: "4 ventilateurs + thermostat" },
      { label: "Garantie", value: "24 mois" },
    ],
    price: "420 000 F CFA",
    priceNum: 420000,
    stock: false,
    stockLabel: "Sur commande (48h)"
  },
  {
    id: 3,
    slug: "cable-ethernet-cat6-305m",
    img: imgCable,
    name: "Bobine Câble Ethernet Cat6 — 305m",
    category: "Câblage Cuivre",
    description: "Câble U/UTP Cat6 certifié LSZH pour installations en faux-planchers et gaines.",
    longDescription: "Bobine de câble Ethernet Cat6 U/UTP de 305 mètres, spécialement sélectionnée pour les installations professionnelles au Sénégal. Gaine LSZH (Low Smoke Zero Halogen) conforme aux normes de sécurité incendie pour bâtiments. Performances testées jusqu'à 250 MHz, idéal pour le Gigabit Ethernet. Compatible avec tous les connecteurs RJ45 Cat6 standard.",
    specs: [
      { label: "Catégorie", value: "Cat6 U/UTP" },
      { label: "Longueur", value: "305 mètres" },
      { label: "Fréquence", value: "250 MHz" },
      { label: "Gaine", value: "LSZH (sécurité incendie)" },
      { label: "Conducteur", value: "Cuivre pur 23 AWG" },
      { label: "Norme", value: "ISO/IEC 11801 Classe E" },
    ],
    price: "45 000 F CFA",
    priceNum: 45000,
    stock: true,
    stockLabel: "En stock à Dakar"
  },
  {
    id: 4,
    slug: "switch-poe-24-ports",
    img: imgRouter,
    name: "Switch PoE 24 Ports Gigabit",
    category: "Réseau Actif",
    description: "Switch manageable 24 ports PoE+ avec VLAN, QoS et supervision SNMP.",
    longDescription: "Ce switch manageable 24 ports Gigabit avec PoE+ (Power over Ethernet) est l'équipement central idéal pour les réseaux d'entreprise. Il alimente directement vos points d'accès Wi-Fi, caméras IP et téléphones VoIP sans câblage électrique additionnel. Interface web de gestion intuitive, support VLAN 802.1Q, QoS avancé et supervision SNMP v3.",
    specs: [
      { label: "Ports", value: "24x GE PoE+ / 4x SFP" },
      { label: "Budget PoE", value: "370W" },
      { label: "Capacité", value: "56 Gbps" },
      { label: "VLAN", value: "802.1Q, jusqu'à 256" },
      { label: "Management", value: "Web, CLI, SNMP v3" },
      { label: "Garantie", value: "12 mois" },
    ],
    price: "195 000 F CFA",
    priceNum: 195000,
    stock: true,
    stockLabel: "En stock à Dakar"
  },
  {
    id: 5,
    slug: "onduleur-ups-1500va",
    img: imgRack,
    name: "Onduleur UPS 1500VA Rack",
    category: "Alimentation",
    description: "UPS 1500VA format rack 2U avec autonomie 20min et port USB de supervision.",
    longDescription: "L'onduleur UPS 1500VA au format rack 2U protège vos équipements réseau et serveurs contre les coupures et fluctuations électriques fréquentes au Sénégal. Avec une autonomie de 20 minutes à pleine charge, il vous donne le temps de sauvegarder vos données et d'éteindre proprement vos systèmes. Port USB pour supervision automatique et arrêt programmé.",
    specs: [
      { label: "Puissance", value: "1500VA / 900W" },
      { label: "Format", value: "Rack 2U / Tour" },
      { label: "Autonomie", value: "20 min (pleine charge)" },
      { label: "Prises", value: "6x IEC C13" },
      { label: "Supervision", value: "USB + logiciel inclus" },
      { label: "Garantie", value: "24 mois + batteries" },
    ],
    price: "150 000 F CFA",
    priceNum: 150000,
    stock: true,
    stockLabel: "En stock à Dakar"
  },
  {
    id: 6,
    slug: "panneau-brassage-cat6-24",
    img: imgCable,
    name: "Panneau de Brassage Cat6 24 Ports",
    category: "Câblage Cuivre",
    description: "Patch panel 24 ports Cat6 format 1U avec guide-câble intégré.",
    longDescription: "Panneau de brassage 24 ports Cat6 au format rack 1U, essentiel pour toute installation réseau professionnelle. Connecteurs RJ45 dorés pour une transmission optimale, numérotation claire pour une gestion simplifiée, et guide-câble intégré pour un câblage propre et organisé. Compatible avec toutes les baies 19\" standard.",
    specs: [
      { label: "Ports", value: "24x RJ45 Cat6" },
      { label: "Format", value: "1U, 19 pouces" },
      { label: "Connecteurs", value: "Dorés, IDC 110" },
      { label: "Blindage", value: "Non blindé (UTP)" },
      { label: "Guide-câble", value: "Intégré" },
      { label: "Certification", value: "Fluke test passé" },
    ],
    price: "28 000 F CFA",
    priceNum: 28000,
    stock: true,
    stockLabel: "En stock à Dakar"
  }
];

export default products;
